import { Routes, Route } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { Toaster } from "react-hot-toast";

import Login from "./components/login.component";
import Home from "./components/home.component";
import Profile from "./components/profile.component";
import InvoiceUpload from "./components/InvoiceUpload.component";
import InvoiceItems from "./components/InvoiceItems.component";
import InvoiceDetail from "./components/InvoiceDetail.component";
import PosImport from "./components/PosImport.component";
import PricebookLookup from "./components/PricebookLookup.component";
import InventoryDashboard from "./components/InventoryDashboard.component";
import SalesDashboard from "./components/SalesDashboard.component";
import CashTracker from "./components/CashTracker.component";
import AtmLoad from "./components/AtmLoad.component";
import Reminders from "./components/Reminders.component";
import Ledger from "./components/Ledger.component";
import SkuMap from "./components/SkuMap.component";
import Vendors from "./components/Vendors.component";
import BarcodeScanner from "./components/BarcodeScanner.component";
import CokeMapper from "./components/CokeMapper.component";
import CigaretteMapper from "./components/CigaretteMapper.component";

import "bootstrap/dist/css/bootstrap.min.css";
import "./App.css";
import "./styles/mobile.css";
import Applayout from "./ui/Applayout.component";
import ProtectedRoute from "./ui/ProtectedRoute.component";
import NoAuthLayout from "./ui/uiElements/NoAuthLayout.component";
import Users from "./components/Users.component";
import SuperAdmin from "./components/SuperAdmin.component";
import ProtectedAdmin from "./ui/ProtectedAdmin.component";
import ProtectedSuperAdmin from "./ui/ProtectedSuperAdmin.component";
import ErrorPage from "./ui/ErrorPage.component";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 0,
    },
  },
});

const App = () => {
  return (
    <QueryClientProvider client={queryClient}>
      <Routes>
        <Route
          element={
            <ProtectedRoute>
              <Applayout />
            </ProtectedRoute>
          }
        >
          <Route index path="/home" element={<Home />} />
          <Route path="/profile" element={<Profile />} />
          <Route path="/invoice" element={<InvoiceUpload />} />
          <Route path="/invoice-items" element={<InvoiceItems />} />
          <Route path="/invoice-detail/:id" element={<InvoiceDetail />} />
          <Route path="/pos-import" element={<PosImport />} />
          <Route path="/pricebook" element={<PricebookLookup />} />
          <Route path="/inventory" element={<InventoryDashboard />} />
          <Route path="/sales" element={<SalesDashboard />} />
          <Route path="/cash-tracker" element={<CashTracker />} />
          <Route path="/atm-load" element={<AtmLoad />} />
          <Route path="/reminders" element={<Reminders />} />
          <Route path="/ledger" element={<Ledger />} />
          <Route path="/sku-map" element={<SkuMap />} />
          <Route path="/vendors" element={<Vendors />} />
          <Route path="/scanner" element={<BarcodeScanner />} />
          <Route path="/coke-mapper" element={<CokeMapper />} />
          <Route path="/cigarette-mapper" element={<CigaretteMapper />} />
          <Route
            path="/admin"
            element={
              <ProtectedAdmin>
                <Users />
              </ProtectedAdmin>
            }
          />
          <Route
            path="/super-admin"
            element={
              <ProtectedSuperAdmin>
                <SuperAdmin />
              </ProtectedSuperAdmin>
            }
          />
        </Route>
        <Route element={<NoAuthLayout />}>
          <Route path="/" element={<Home />} />
          <Route path="/login" element={<Login />} />
        </Route>
        <Route path="*" element={<ErrorPage errorCode="404" description="Page Not Found" />} />
      </Routes>

      <Toaster
        position="top-center"
        gutter={12}
        containerStyle={{ margin: "8px" }}
        toastOptions={{
          success: {
            duration: 3000,
          },
          error: {
            duration: 3000,
          },
          style: {
            fontSize: "16px",
            maxWidth: "500px",
            padding: "16px 24px",
            backgroundColor: "white",
            color: "black",
          },
        }}
      />
    </QueryClientProvider>
  );
};

export default App;
